import { ReactElement } from 'react';
import ForceFlagControl, { ForceFlagControlProps } from './ForceFlagControl';

/**
 * Editor for `parser_vars.atmosphere.force_synthetic_dp` — replaces the
 * measured DynPres channels with the synthesized DynPresSynth channel during
 * reprocessing, even when probe dynamic pressure is present.
 */
export default function ForceSyntheticDpControl(props: ForceFlagControlProps): ReactElement {
  return (
    <ForceFlagControl
      {...props}
      id="force-synthetic-dp"
      label="Force synthetic dynamic pressure"
      hint="Reprocess uses the wheel-speed-derived dynamic pressure even when probe DP is present"
    />
  );
}
